<template>
  <div :class="classModifiers">
    <div class="no-data-dashed-box__icon"></div>
    <div class="no-data-dashed-box__text">
      <slot></slot>
    </div>
  </div>
</template>

<script src="./no-data-dashed-box.js"></script>
<style src="./no-data-dashed-box.scss" lang="scss"></style>
